import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import EntityOverview from './EntityOverview';
import MainDashboard from '../main_dashboard/MainDashboard';
import OrderDashboard from '../order_dashboard/OrderDashboard';

export default function EntityDetail({ props }) {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search).get('content');
  const [content, setContent] = useState(urlParams);

  return (
    <div>
      <button
        type="button"
        onClick={() => navigate('/')}
        className="rounded bg-light-blue py-2 px-3 text-sm text-primary-blue shadow-sm hover:bg-navy-blue hover:text-white my-4"
      >
        Back to Search
      </button>
      <EntityOverview props={props} />
      <div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav
              className="-mb-px flex space-x-8 cursor-pointer max-w-max"
              aria-label="Tabs"
            >
              <div
                onClick={() => setContent('dashboard')}
                className={classNames(
                  !content || content === 'dashboard'
                    ? 'border-primary-blue text-primary-blue'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 py-4 px-1 text-sm',
                )}
              >
                Dashboard
              </div>
              <div
                onClick={() => setContent('orders')}
                className={classNames(
                  content === 'orders'
                    ? 'border-primary-blue text-primary-blue'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 py-4 px-1 text-sm',
                )}
              >
                Orders
              </div>
            </nav>
          </div>
        </div>
      </div>
      {!content || content === 'dashboard' ? (
        <MainDashboard props={props} />
      ) : (
        <OrderDashboard props={props} />
      )}
    </div>
  );
}
